// extracted by mini-css-extract-plugin
export var messageSideLeft = "_je-1";
export var messageSideRight = "_je-2";
export var subscribeToBackInStockBubbleContainer = "_je-0";